import Vue from 'vue'
import VueRouter from 'vue-router'

import AdminLogin from '../components/Admin/Login.vue'
import Index from '../components/Admin/Index.vue'
import Welcome from '../components/Admin/Welcome.vue'
import UserList from '../components/Admin/User/Users.vue'
import DealerList from '../components/Admin/User/Dealers.vue'
import Swipers from '../components/Admin/Swiper/Swipers.vue'
import Pianos from '../components/Admin/Swiper/Pianos.vue'
import Courses from '../components/Admin/Swiper/Classes.vue'
import Abouts from '../components/Admin/Swiper/Abouts.vue'
import Questions from '../components/Admin/Question/Questions.vue'
import GoodsClass from '../components/Admin/Goods/GoodsClass.vue'
import GoodsList from '../components/Admin/Goods/Goods.vue'
import GoodsAdd from '../components/Admin/Goods/Add.vue'
import GoodEdit from '../components/Admin/Goods/Edit.vue'
import OrderList from '../components/Admin/Order/Orders.vue'
import Params from '../components/Admin/Params/Params.vue'
import ParamsEdit from '../components/Admin/Params/Edit.vue'

Vue.use(VueRouter)

const routes = [
  //后端跳由
  { path: '/admin', component:AdminLogin },
  { path: '/index', component: Index, redirect:'/welcome', children:[
    { path:'/welcome', component:Welcome},
    { path:'/users', component:UserList},//用户列表 
    { path:'/dealers', component:DealerList},//经销商用户列表 
    { path:'/swipers', component:Swipers},//轮播图列表
    { path:'/pianos', component:Pianos},//名琴欣赏
    { path:'/courses', component:Courses},//在线课程
    { path:'/abouts', component:Abouts},//关于VOM
    { path:'/questions', component:Questions},//公告列表    
    { path:'/goodsclass', component:GoodsClass},//商品类型
    { path:'/goodslist', component:GoodsList},//商品列表
    { path:'/goodsadd', component:GoodsAdd},//添加商品
    { path:'/goodsedit/:id', component:GoodEdit},//修改商品
    { path:'/orderlist', component:OrderList},//订单列表
    { path:'/params', component:Params},//参数列表
    { path:'/paramsedit/:id', component:ParamsEdit},//修改参数
    
  ]}
]

const router = new VueRouter({
  routes
})

export default router
